import { render, staticRenderFns } from "./Drag.vue?vue&type=template&id=6b836a27&scoped=true&"
import script from "./Drag.vue?vue&type=script&lang=js&"
export * from "./Drag.vue?vue&type=script&lang=js&"
import style0 from "./Drag.vue?vue&type=style&index=0&id=6b836a27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b836a27",
  null
  
)

export default component.exports